import {
  Required,
  DataValidator,
  transformKeys,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface KnowledgeFolderRenameResponse {
  folder: Folder;
};

export interface Folder {
  id: number;
  folder_uuid: string;
  parent_folder_id: number;
  user_id: number;
  folder_name: string;
  create_time: number;
  update_time: number;
  deleted_time?: string;
};

class RenameFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;
}

class KnowledgeFolderRenameData {
  @Required("Folder cannot be empty")
  @ValidateNested(RenameFolderData)
  folder: RenameFolderData;
}

const transformAndValidateData = (
  response: KnowledgeFolderRenameResponse
): KnowledgeFolderRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeFolderRenameData);
  } catch (error) {
    console.error("Knowledge folder rename data validation failed:", error.message);
    throw error;
  }
};

/** 知识库目录重命名 */
export const knowledgeRenameFolder = async ({
  folderId,
  folderName
}: {
  folderId: number,
  folderName: string
}) => {
  const res = await api.post<KnowledgeFolderRenameResponse>('/knowledge/rename_folder', {
    folder_id: folderId,
    folder_name: folderName,
  });
  const data = transformAndValidateData(res.data);
  return data;
}